import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages, faEllipsis } from '@fortawesome/free-solid-svg-icons';
import api from '../../api';
import { z } from 'zod';
import { DeleteButton, EditButton } from '../../components/TableActionButtons';

export const getConstitutionsTableConfig = (handleEdit, handleDelete, tr) => [
    {
        header: () => (
            <span className="flex items-center">
                <FontAwesomeIcon icon={faImages} className="w-4 h-4 mr-2" />
                {tr('table.name')}
            </span>
        ),
        accessorKey: 'name',
        cell: ({ row }) => (
            <div className="flex flex-col justify-start items-start truncate">
                <div className="text-left flex items-center">
                    <span className="font-medium">{row.original.name}</span>
                </div>
            </div>
        )
    },
    {
        header: () => (
            <span className="flex items-center justify-center">
                <FontAwesomeIcon icon={faEllipsis} className="w-4 h-4 mr-2" />
                {tr('table.actions')}
            </span>
        ),
        id: 'actions',
        cell: ({ row }) => (
            <div className="flex items-center justify-center gap-3">
                <EditButton onClick={() => handleEdit(row.original)} row={row} />
                <DeleteButton onClick={handleDelete} row={row} />
            </div>
        )
    }
];

export const PAGE_CONFIG = {
    BREADCRUMB: [
        { label: 'Home', link: '/' },
        { label: 'Administration', link: null },
        { label: 'Media Types', link: '/media-types' }
    ],
    PAGE_TITLE: 'Media Types',
    GET_QUERY_KEY: 'media-types',
    API_CALL: () => api.mediaTypes.getMediaTypes(),
    DEFAULT_ERROR_MESSAGE: 'Failed to fetch media types',
    SELECT: (data) => data?.data,
    //Delete
    DELETE_API_CALL: (id) => api.mediaTypes.deleteMediaType(id),
    DELETE_ERROR_MESSAGE: 'Failed to delete media type',
    DELETE_SUCCESS_MESSAGE: 'Media type deleted successfully',
    //Create
    CREATE_API_CALL: (data) => api.mediaTypes.createMediaType(data),
    CREATE_ERROR_MESSAGE: 'Failed to create media type',
    CREATE_SUCCESS_MESSAGE: 'Media type created successfully',
    // Update
    UPDATE_API_CALL: (id, data) => api.mediaTypes.updateMediaType(id, data),
    UPDATE_ERROR_MESSAGE: 'Failed to update media type',
    UPDATE_SUCCESS_MESSAGE: 'Media type updated successfully'
};

export const INITIAL_FORM_STATE = {
    name: ''
};

export const INITIAL_ERROR_STATE = {
    name: ''
};

export const getFormConfig = (formData, handleInputChange) => [
    {
        formControl: 'input',
        autoComplete: 'off',
        label: 'Media Type',
        id: 'name',
        placeholder: 'Enter Media Type',
        name: 'name',
        type: 'text',
        required: true,
        value: formData.name,
        onChange: (e) => handleInputChange('name', e.target.value)
        // error: touched.firstname ? errors.firstname : ''
    }
];
export const CONSTITUTION_SCHEMA = z.object({
    name: z.string().min(3, 'Media Type must be at least 3 characters')
});
